export enum SlideShowPanels {
  DEFAULT = 'default',
  FONT = 'font',
  TEXT_FILL = 'text_fill',
  OUTLINE = 'outline',
  BACKGROUND_COLOR = 'background_color',
  SHADOW = 'shadow',
  REMOVE_COLOR = 'remove_color',
  TINT = 'tint',
  MULTIPLY = 'multiply',
  GLOW = 'glow',
  LIST_COLOR = 'list_color',
  BLOCK_TRANSITION = 'block_transition',
  INTRO_ANIMATION = 'intro-animation',
  OUTRO_ANIMATION = 'outro-animation',
}
